export enum RegionType {
  DEFAULT = '',
  KECAMATAN = 'KECAMATAN',
  KABUPATEN = 'KABUPATEN',
  PROVINSI = 'PROVINSI',
}
